export class PortalError {
    RunId = 0;
    ErrorCode = 0;

    constructor() {
    }

}

